import { Page } from './Page';
export * from './PageBoundary';
export * from './Page';
export * from './asyncComHoc';
export * from './editSiderMenus';
export * from './generateRoute';
export default Page;
//# sourceMappingURL=es/index.js.map